exports.AD_DEEP_LINKS_TOTAL = 4;
exports.RESULT_DEEP_LINKS_TOTAL = 4;
